
<div mdbModal #addModal="mdbModal" class="modal fade" id="basicExample" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 1050 !important">
    <div class="modal-dialog modal-size" role="document">
        <div class="modal-content">
            <div class="header-div modal-header head-modals">
                <h4 class="modal-title w-100 title-modals" id="myModalLabel">{{ titleModal }}</h4>
                <button type="button" class="close x-modals" data-dismiss="modal" aria-label="Close" (click)="addModal.hide()">
                    <span aria-hidden="true" class="p-0 m-0">×</span>
                </button>
            </div>
            <div class="modal-body modals-body">
              <div class="container mt-4 px-4">
                <form [formGroup]="form" class="text-center forms-text">
                  <div class="mx-auto px-4" style="background-color: white;">
                    <div class="row">

                    <div class="col-12 col-md-6 input-time md-form md-outline">
                        <div style="background-color: white !important; height: 36px; border-radius: 5px;">
                            <mdb-date-picker
                            [inline]="true"
                            name="startdate"
                            [options]="myDatePickerOptions"
                            [placeholder]="'Fecha Inicio'"
                            label="Fecha Inicio"
                            [formControlName]="'startdate'">
                            </mdb-date-picker>
                        </div>
                        </div>

                        <div class="col-12 col-md-6 input-time md-form md-outline">
                        <div style="background-color: white !important; height: 36px; border-radius: 5px;">
                            <mdb-date-picker
                            [inline]="true"
                            name="enddate"
                            [options]="myDatePickerOptions"
                            [placeholder]="'Fecha Fin'"
                            label="Fecha Fin"
                            [formControlName]="'enddate'">
                            </mdb-date-picker>
                        </div>
                    </div>
                                                        
                    <div class="col-12 col-md-6 md-form md-outline">
                        <mdb-select-2 [outline]="true" placeholder="Seleccionar Tipo" label="Tipo Instrumento" [formControlName]="'type'">
                            <mdb-select-option *ngFor="let option of typesInstruments" [value]="option.gid" (click)="changedType(option)">{{ option.nombre | titlecase }}</mdb-select-option>
                        </mdb-select-2>
                    </div>

                    <div class="col-12 col-md-6 md-form md-outline">
                      <mdb-select-2 [outline]="true" placeholder="Seleccionar Id" label="Id Instrumento" [formControlName]="'instrument'">
                          <mdb-select-option *ngFor="let option of instruments" [value]="option.gid" (click)="changedInstrument(option)">{{ option.nombre }} ({{ option.codigo }})</mdb-select-option>
                      </mdb-select-2>
                    </div>

                    <div class="col-12 col-md-6 md-form md-outline">
                      <mdb-select-2 [outline]="true" placeholder="Seleccionar Id" label="Tipo Sensor" [formControlName]="'sensorType'">
                          <mdb-select-option *ngFor="let option of sensorTypes" [value]="option.gid" (click)="changedSensorType(option)">{{ option.nombre | titlecase }}</mdb-select-option>
                      </mdb-select-2>
                    </div>

                    <div class="col-12 col-md-6 md-form md-outline">
                      <mdb-select-2 [outline]="true" placeholder="Seleccionar Id" label="Id Sensor" [formControlName]="'sensor'">
                          <mdb-select-option *ngFor="let option of sensors" [value]="option.gid" (click)="changedSensor(option)">{{ option.codigo }}</mdb-select-option>
                      </mdb-select-2>
                    </div>


                    </div>

                  </div>         
              </form>
              </div>
              
            </div>
            <div class="modal-footer modals-footer pt-3">
                <button type="button" mdbBtn class="waves-light button-cancel-modals" (click)="addModal.hide()" mdbWavesEffect>Cancelar</button>
                <button type="button" mdbBtn class="waves-light button-accept-modals" (click)="download()" [disabled]="isButtonDisabled" mdbWavesEffect>Descargar</button>
            </div>
        </div>
    </div>
</div>

<!-- <app-modal-accept [modalInfo]="modalInfo" [stateModal]="stateModalAlert"
(reponseStateModalAccept)="onResponseAlert($event)"></app-modal-accept> -->

